export default "__VITE_ASSET__DSv30_Gw__"